import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { StrapiService } from '../../../services/strapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../../services/message.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  datas:any=[];searchTerm;
  categories:any=[];
  errores:string="";
  totalLength:any;
  page:number = 1;
  category:any;
  categorias:any=[];
  url: any;
  novedades: Object;
  totalcounter: string;
  current_url: any;
  messages: any[] = [];
  subscription: Subscription;
  constructor(
  	private title: Title,
    private meta: Meta,
    public strapiserv:StrapiService,
    private http: HttpClient,
    private domSanitizer: DomSanitizer,
    private _router:Router,
    private messageService: MessageService,
    private translate: TranslateService,
  ){ translate.addLangs(['es','en']);
     translate.setDefaultLang('es');
     this.subscription = this.messageService.onMessage().subscribe(message => {
         if (message) {
             this.messages.push(message);
             this.translate.setDefaultLang(message.text);
         } else {
             // clear messages when empty message received
             this.messages = [];
         }
     }); }


  myCategories(datas: any){
     let newArr = [];
     let uniqueArray:any;
      datas.forEach((item, index) => {
        newArr.push(item.category.name);
        uniqueArray = newArr.filter(function(item, pos, self) {
          return self.indexOf(item)===pos;
        })


      });
      return uniqueArray;
  }


  ngOnInit(): void {
    this.current_url=this.domSanitizer.bypassSecurityTrustResourceUrl('https://blog-esource.daxosline.com.co/wordpress/');
    this.http.get(`${environment.apiurl}posts?_embed&per_page=5`).subscribe(data =>{
      this.datas=data;
    })
    this.http.get(`${environment.apiurl}posts?_embed&per_page=1`,{observe: 'response'}).subscribe(data =>{
      this.totalcounter=data.headers.get('X-WP-Total');
    })

    this.http.get(`${environment.apiurl}categories`).subscribe(data =>{
      this.categories=data;
    })
    this.http.get(`${environment.apiurl}posts?category_slug=Novedades&per_page=3`).subscribe(data =>{
      this.novedades=data;
    })
  }


  filterRelevante(datas: any) : any {
      return datas.filter(data => data.relevante)
  }


  onPageChange(page:number){
    window.scrollTo(0,0);
    this.http.get('https://blog-esource.daxosline.com.co/wordpress/index.php/wp-json/wp/v2/posts?_embed&per_page=5&page='+page).subscribe(data =>{
      this.datas=data;
    })
  }
  testing(id:boolean){
    let value : string;
    id==true ? value="searchelement" : value="searchelement2";
    let data = (document.getElementById(value) as HTMLInputElement).value;
    data=='' ? null : this._router.navigate(['/search/'+data]);
  }

}
